import React from 'react';

export default function Loading() {
  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 9999,
      display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      background: 'rgba(15,23,42,0.6)',
      backdropFilter: 'blur(8px)',
      gap: 16,
    }}>
      <div style={{ position: 'relative', display: 'inline-flex', width: 60, height: 60 }}>
        <svg style={{ position: 'absolute', inset: 0, animation: 'ge-spin 1.4s linear infinite' }} viewBox="0 0 60 60">
          <circle cx="30" cy="30" r="26" fill="none" stroke="#1e3a4c" strokeWidth="2.5" strokeDasharray="120 44" strokeLinecap="round" />
        </svg>
        <div style={{
          position: 'absolute', inset: 0,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          <div style={{
            width: 36, height: 36, borderRadius: '50%',
            background: 'linear-gradient(135deg, #3d7a9c, #1e3a4c)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            boxShadow: '0 4px 12px rgba(82,148,181,0.4)',
          }}>
            <span style={{ color: '#fff', fontWeight: 900, fontSize: '0.62rem', letterSpacing: 0.5 }}>GE</span>
          </div>
        </div>
      </div>
      <span style={{ color: '#e2e8f0', fontWeight: 500, fontSize: '0.85rem', letterSpacing: 0.4 }}>
        Carregando…
      </span>
      <style>{`@keyframes ge-spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}
